"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalProvider = exports.PortalParentProvider = exports.usePortalParent = exports.parentContext = exports.usePortal = exports.context = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const PortalState_1 = require("./PortalState");
const defaultPortalState = new PortalState_1.PortalState();
exports.context = React.createContext(defaultPortalState);
const usePortal = () => React.useContext(exports.context);
exports.usePortal = usePortal;
/**
 * Default parent element for portals rendered inside this subtree. When no
 * explicit `parent` prop is passed to `<Portal>`, the portal mounts under
 * this element instead of `document.body`.
 */
exports.parentContext = React.createContext(null);
const usePortalParent = () => React.useContext(exports.parentContext);
exports.usePortalParent = usePortalParent;
exports.PortalParentProvider = exports.parentContext.Provider;
const PortalProvider = ({ children }) => {
    const parentState = (0, exports.usePortal)();
    const state = React.useMemo(() => {
        const state = new PortalState_1.PortalState();
        state.parent = parentState;
        return state;
    }, [parentState]);
    return React.createElement(exports.context.Provider, { value: state }, children);
};
exports.PortalProvider = PortalProvider;
